import { LinkModel } from '@/types';
import { useSession, signIn } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import { openLink } from '@/utils';
import { useRouter } from 'next/router';
import classNames from 'classnames';

interface ILoginLogoutBtnModel {
  loginLink: LinkModel;
  logoutLink?: LinkModel;
  className?: string;
}

const LoginLogoutBtn = ({ loginLink, logoutLink, className }: ILoginLogoutBtnModel) => {
  const { data: userSession } = useSession();
  const isLoggedIn = !!userSession?.user?.email;
  const router = useRouter();
  const t = useTranslations();

  const onClick = () => {
    if (isLoggedIn) {
      if (logoutLink) {
        openLink(router, logoutLink);
      } else {
        openLink(router, { href: '/open-logout' });
      }
    } else {
      if (loginLink) {
        openLink(router, loginLink);
      } else signIn();
    }
  };

  return (
    <div className={classNames('btn secondary v2 !px-5 !py-[11px] lg:!bg-white/90', className)} onClick={onClick}>
      {t(isLoggedIn ? 'general.$logout' : 'general.$login')}
    </div>
  );
};

export default LoginLogoutBtn;
